export interface Candidate {
  userId: number;
  userImageUrl: string;
  uniqueId: string;
  header: string;
  description: string;
  starred: boolean;
  aspiringBusinessCategories: string[];
  internshipResultCompanies: string[];
  studentEndeavorContent: string | undefined;
  preferredJobTypes: string[];
  preferredWorkPrefectures: string[];
}

export enum DisplayModeStorageKey {
  Standard = "candidateDisplayMode",
  Agent = "candidateAgentDisplayMode"
}
